import { render, staticRenderFns } from "./review-detail.vue?vue&type=template&id=124b4aec&scoped=true&"
import script from "./review-detail.vue?vue&type=script&lang=js&"
export * from "./review-detail.vue?vue&type=script&lang=js&"
import style0 from "./review-detail.vue?vue&type=style&index=0&id=124b4aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b4aec",
  null
  
)

export default component.exports